import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import setStyles from "../../setStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    maxWidth: "800px",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 25px",
    },
  },
  h2: {
    color: "#05070B",
    ...setStyles.nunitoSansBold,
    fontSize: "36px",
    paddingBottom: "16px",
  },
  p: {
    color: "#404040",
    opacity: 0.8,
    ...setStyles.nunitoSansRegular,
    fontSize: "18px",
  },
}));

const Header = ({ headingText = "" }) => {
  const classes = useStyles();
  return (
    <>
      <h2 className={classes.h2}>{headingText}</h2>
      <p className={classes.p}>Keep up with the latest in their career.</p>
    </>
  );
};

export default Header;
